import Secrets from './config/secrets';

export default Secrets
